import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../CSS/Footer.css";
import '@fortawesome/fontawesome-free/css/all.css';
import Location from "../Images/Location.gif";
import Location1 from "../Images/location-bgr.gif";
import Phone from "../Images/Phone.gif";
import Phone1 from "../Images/mobilebgr.gif";
import Email from "../Images/EmailAnim.gif";
import Email1 from "../Images/mailbgr.gif";
import FloatingIcons from "./FloatingIcons";

const Footer=()=>{
    return(
        <footer className="ftco-footer ftco-section img">
    <div className="overlay" />
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-5">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">About Us</h2>
            <p className="text-justify">
            Welcome to Sports Academy, we are dedicated to fostering the growth of badminton enthusiasts of all ages and skill levels.
            </p>
            <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
              <li className="ftco-animate">
                <a  className="social-button social-button--facebook">
                <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="ftco-animate">
                <a className="social-button social-button--youtube">
                <i className="fas fa-play-circle"></i>
                </a>
              </li>
              <li className="ftco-animate">
                <a href="https://www.instagram.com/balaji_coach7/"  target="_blank"  className="social-button social-button--instagram">
                <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
       
        <div className="col-md-3">
          <div className="ftco-footer-widget  ml-md-4">
            <h2 className="ftco-heading-2">Sports</h2>
            <ul className="list-unstyled">
              <li>
                <a href="/services/Badminton" className="py-2 d-block">
                  Badminton
                </a>
              </li>
             
              <li>
                <a href="/services/Dance" className="py-2 d-block">
                  Dance
                </a>
              </li>
              {/* <li>
                <a href="#" className="py-2 d-block">
                 Yoga
                </a>
              </li> */}
             
            </ul>
          </div>
        </div>
        {/* <div className="col-md-2">
          <div className="ftco-footer-widget  mb-4">
          <h2 className="ftco-heading-2 mb-4"></h2>
            <ul className="list-unstyled" style={{paddingTop:"35px"}}>
            <li>
                <a href="#" className="py-2 d-block">
                  Chess
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Table Tennis
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Hockey
                </a>
              </li>
              <li>
                <a href="#" className="py-2 d-block">
                  Throw Ball
                </a>
              </li>
            </ul>
          </div>
        </div> */}
        <div className="col-md-4">
          <div className="ftco-footer-widget mb-4">
            <h2 className="ftco-heading-2">Address</h2>
            <div className="block-23 mb-3"> 
              <ul>
                <li>
                <a href="https://www.google.com/maps/place/Balaji+Badminton+Academy/@11.7862719,76.1247332,923211m/data=!3m1!1e3!4m12!1m2!2m1!1sBalaji+Sports+Academy!3m8!1s0x3a525bba69329307:0x973d7cdad8647c0b!8m2!3d12.8488616!4d80.2280457!9m1!1b1!15sChVCYWxhamkgU3BvcnRzIEFjYWRlbXmSAQtzcG9ydHNfY2x1YuABAA!16s%2Fg%2F11fsq2j89t!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D">
                <img 
                  src={Location1} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  />
                  <span className="text" style={{color:"white", paddingLeft:"5px"}}>
                  No.10, Thalambur road, Next to Mount litera zee school, Navalur , Chengalpattu - 600130.
                  </span>
                  </a>
                </li>
                <li>
                <a href="tel:+919629672378">
                <img 
                  src={Phone1} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  /> 
                  <span className="text" style={{ paddingLeft:"5px"}}>+91 96296 72378</span>
                </a>
              </li>
              <li>
                <a href="mailto:balajiwei@gmail.com">
                <img 
                  src={Email1} 
                  alt="Email Icon" 
                  style={{ width: '30px', marginRight: '5px' }} 
                  />
                  <span className="text"  style={{ paddingLeft:"5px"}}>balajiwei@gmail.com</span>
                </a>
              </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
        <p>
          With <i className="fas fa-heart" style={{ color: "red" }} aria-hidden="true"></i> from{" "}
          <a href="https://www.datadna.in/" target="_blank" rel="noopener noreferrer" className="footercompany">
            DATADNA
          </a>
        </p>

        </div>
      </div>
    </div>
    <div className="footer-icons-wrapper">
          <FloatingIcons isFooter={true} />
        </div>
  </footer>
    );
}


export default Footer;